/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_BuscadorPersona as BuscadorPersona,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SelectorMultiple as SelectorMultiple,
  rec_Yx as Yx,
  rec__k as _k,
  rec_api as api,
  rec_bk as bk,
  rec_fk as fk,
  rec_gk as gk,
  rec_hk as hk,
  rec_ra as ra,
  rec_vk as vk,
  rec_yk as yk,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function FormularioUnidad(e) {
  let t = (0, ReactCompiler.c)(74),
    { datos: n, onClose: r, onGuardado: i } = e,
    a = !!n.editar,
    o;
  t[0] !== n.niveles || t[1] !== a
    ? ((o = a ? [] : (n.niveles ?? [])),
      (t[0] = n.niveles),
      (t[1] = a),
      (t[2] = o))
    : (o = t[2]);
  let s = o,
    [c, l] = (0, React.useState)(a ? n.editar.tipo : (n.tipo ?? s[0]?.codigo)),
    [u, f] = (0, React.useState)(a ? n.editar.nombre : ``),
    p;
  t[3] !== n.editar || t[4] !== a
    ? ((p =
        a && Array.isArray(n.editar.responsables)
          ? n.editar.responsables.map(bk)
          : []),
      (t[3] = n.editar),
      (t[4] = a),
      (t[5] = p))
    : (p = t[5]);
  let [m, h] = (0, React.useState)(p),
    [_, v] = (0, React.useState)(``),
    [y, b] = (0, React.useState)(!1),
    x;
  t[6] !== n.editar || t[7] !== a
    ? ((x = a && Array.isArray(n.editar.sedes) ? n.editar.sedes.map(yk) : []),
      (t[6] = n.editar),
      (t[7] = a),
      (t[8] = x))
    : (x = t[8]);
  let [S, C] = (0, React.useState)(x),
    w;
  t[9] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((w = []), (t[9] = w))
    : (w = t[9]);
  let [T, E] = (0, React.useState)(w),
    D,
    O;
  (t[10] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((D = () => {
        let e = !0;
        return (
          api(`/sedes`)
            .then((t) => {
              e && E(t ?? []);
            })
            .catch(vk),
          () => {
            e = !1;
          }
        );
      }),
      (O = []),
      (t[10] = D),
      (t[11] = O))
    : ((D = t[10]), (O = t[11])),
    (0, React.useEffect)(D, O));
  let k;
  t[12] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((k = function (e) {
        C((t) =>
          t.some((t) => t.sedeId === e.id)
            ? t.filter((t) => t.sedeId !== e.id)
            : [
                ...t,
                {
                  sedeId: e.id,
                  nombre: e.nombre,
                },
              ],
        );
      }),
      (t[12] = k))
    : (k = t[12]);
  let A = k,
    j;
  t[13] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((j = function (e) {
        h((t) =>
          t.some((t) => t.id === e.id)
            ? t
            : [
                ...t,
                {
                  ...e,
                  posicion: t.length === 0 ? `RESPONSABLE` : `AUXILIAR`,
                },
              ],
        );
      }),
      (t[13] = j))
    : (j = t[13]);
  let M = j,
    N;
  t[14] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((N = function (e) {
        h((t) => t.filter((t) => t.id !== e));
      }),
      (t[14] = N))
    : (N = t[14]);
  let P = N,
    F;
  t[15] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((F = function (e, t) {
        h((n) =>
          n.map((n) =>
            n.id === e
              ? {
                  ...n,
                  posicion: t,
                }
              : n,
          ),
        );
      }),
      (t[15] = F))
    : (F = t[15]);
  let I = F,
    L;
  t[16] !== n.editar ||
  t[17] !== n.padreId ||
  t[18] !== a ||
  t[19] !== y ||
  t[20] !== u ||
  t[21] !== i ||
  t[22] !== m ||
  t[23] !== S ||
  t[24] !== c
    ? ((L = async function (e) {
        if ((e.preventDefault(), y)) return;
        (b(!0), v(``));
        let t = {
          tipo: c,
          nombre: u,
          padreId: a ? n.editar.padreId : n.padreId,
          responsables: m.map(_k),
          sedes: S,
        };
        try {
          (a
            ? await api(`/unidades/${n.editar.id}`, {
                method: `PUT`,
                body: JSON.stringify(t),
              })
            : await api(`/unidades`, {
                method: `POST`,
                body: JSON.stringify(t),
              }),
            i());
        } catch (e) {
          (v(e.message), b(!1));
        }
      }),
      (t[16] = n.editar),
      (t[17] = n.padreId),
      (t[18] = a),
      (t[19] = y),
      (t[20] = u),
      (t[21] = i),
      (t[22] = m),
      (t[23] = S),
      (t[24] = c),
      (t[25] = L))
    : (L = t[25]);
  let R = L,
    z;
  t[26] !== a || t[27] !== c
    ? ((z = a ? `Editar ${Yx(c).toLowerCase()}` : `Agregar al organigrama`),
      (t[26] = a),
      (t[27] = c),
      (t[28] = z))
    : (z = t[28]);
  let ee;
  t[29] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((ee = (e) => f(e.target.value)), (t[29] = ee))
    : (ee = t[29]);
  let te;
  t[30] === u
    ? (te = t[31])
    : ((te = (
        <input
          className={Lo}
          placeholder={`Nombre`}
          value={u}
          onChange={ee}
          required={!0}
          autoFocus={!0}
        />
      )),
      (t[30] = u),
      (t[31] = te));
  let B;
  t[32] !== s || t[33] !== c
    ? ((B = s.length > 1 && (
        <label
          className={`text-xs text-(--text)`}
          children={[
            `¿Qué es?`,
            <SelectorMultiple
              value={c}
              onChange={(e) => l(e || s[0].codigo)}
              opciones={s.map(gk)}
            />,
          ]}
        />
      )),
      (t[32] = s),
      (t[33] = c),
      (t[34] = B))
    : (B = t[34]);
  let V;
  t[35] !== a || t[36] !== S || t[37] !== T
    ? ((V = !a && T.length > 0 && (
        <div
          children={[
            <p
              className={`mb-1.5 text-xs text-(--text)`}
              children={
                S.length > 1
                  ? `Se van a crear ${S.length} unidades, una por sede. Cada una lleva su equipo y sus proyectos.`
                  : `En qué sede trabaja. Si marcás varias, se crea una unidad por cada una.`
              }
            />,
            <div
              className={`flex flex-wrap gap-1.5`}
              children={T.map((e) => {
                let t = S.some((t) => t.sedeId === e.id);
                return (
                  <button
                    key={e.id}
                    type={`button`}
                    onClick={() => A(e)}
                    aria-pressed={t}
                    className={`rounded-full border px-3 py-2 text-sm transition ${t ? `border-(--accent) bg-(--accent-bg) text-(--accent-texto)` : `border-(--border) text-(--text)`}`}
                    children={e.nombre}
                  />
                );
              })}
            />,
          ]}
        />
      )),
      (t[35] = a),
      (t[36] = S),
      (t[37] = T),
      (t[38] = V))
    : (V = t[38]);
  let H;
  t[39] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((H = (
        <p
          className={`mb-1 text-xs text-(--text)`}
          children={`Quiénes trabajan acá y en qué puesto. El puesto decide a quién se le puede encargar trabajo: siempre hacia abajo, nunca al revés.`}
        />
      )),
      (t[39] = H))
    : (H = t[39]);
  let ne;
  t[40] !== m || t[41] !== c
    ? ((ne = m.length > 0 && (
        <ul
          className={`mb-2 flex flex-col gap-1.5`}
          children={m.map((e) => (
            <li
              key={e.id}
              className={`flex flex-wrap items-center gap-2 rounded-2xl border border-(--border) px-3 py-2 text-sm text-(--text-h)`}
              children={[
                <span
                  className={`min-w-0 flex-1 truncate`}
                  children={e.nombre}
                />,
                <div
                  className={`w-52 shrink-0`}
                  children={
                    <SelectorMultiple
                      value={e.posicion || `AUXILIAR`}
                      onChange={(t) => I(e.id, t || `AUXILIAR`)}
                      opciones={fk(c)}
                    />
                  }
                />,
                <button
                  type={`button`}
                  onClick={() => P(e.id)}
                  className={`text-(--text) hover:text-(--error)`}
                  children={(0, JSXRuntime.jsx)(ra, {
                    className: `h-4 w-4`,
                  })}
                />,
              ]}
            />
          ))}
        />
      )),
      (t[40] = m),
      (t[41] = c),
      (t[42] = ne))
    : (ne = t[42]);
  let re = m.length ? `Agregar otra persona…` : `Buscar persona…`,
    ie;
  t[43] === m ? (ie = t[44]) : ((ie = m.map(hk)), (t[43] = m), (t[44] = ie));
  let U;
  t[45] !== re || t[46] !== ie
    ? ((U = <BuscadorPersona placeholder={re} excluirIds={ie} onSelect={M} />),
      (t[45] = re),
      (t[46] = ie),
      (t[47] = U))
    : (U = t[47]);
  let ae;
  t[48] !== ne || t[49] !== U
    ? ((ae = <div children={[H, ne, U]} />),
      (t[48] = ne),
      (t[49] = U),
      (t[50] = ae))
    : (ae = t[50]);
  let oe;
  t[51] === _
    ? (oe = t[52])
    : ((oe = _ && <p className={`text-sm text-(--error)`} children={_} />),
      (t[51] = _),
      (t[52] = oe));
  let se;
  t[53] === r
    ? (se = t[54])
    : ((se = (
        <button
          type={`button`}
          onClick={r}
          className={zo}
          children={`Cancelar`}
        />
      )),
      (t[53] = r),
      (t[54] = se));
  let ce = a ? `Guardando…` : `Creando…`,
    le = a ? `Guardar` : `Crear`,
    ue;
  t[55] !== y || t[56] !== ce || t[57] !== le
    ? ((ue = (
        <AccionAsync
          type={`submit`}
          ocupado={y}
          textoOcupado={ce}
          children={le}
        />
      )),
      (t[55] = y),
      (t[56] = ce),
      (t[57] = le),
      (t[58] = ue))
    : (ue = t[58]);
  let de;
  t[59] !== se || t[60] !== ue
    ? ((de = (
        <div className={`mt-2 flex justify-end gap-2`} children={[se, ue]} />
      )),
      (t[59] = se),
      (t[60] = ue),
      (t[61] = de))
    : (de = t[61]);
  let fe;
  t[62] !== R ||
  t[63] !== te ||
  t[64] !== B ||
  t[65] !== V ||
  t[66] !== ae ||
  t[67] !== oe ||
  t[68] !== de
    ? ((fe = (
        <form
          onSubmit={R}
          className={`flex flex-col gap-3`}
          children={[te, B, V, ae, oe, de]}
        />
      )),
      (t[62] = R),
      (t[63] = te),
      (t[64] = B),
      (t[65] = V),
      (t[66] = ae),
      (t[67] = oe),
      (t[68] = de),
      (t[69] = fe))
    : (fe = t[69]);
  let pe;
  return (
    t[70] !== r || t[71] !== z || t[72] !== fe
      ? ((pe = <Modal titulo={z} onClose={r} children={fe} />),
        (t[70] = r),
        (t[71] = z),
        (t[72] = fe),
        (t[73] = pe))
      : (pe = t[73]),
    pe
  );
}
